import { LeftOutlined } from '@ant-design/icons'
import { StoreDetailsTankRundown } from '@components/StoreMonitoring/StoreDetailsPage/StoreDetailsTankRundown'
import { GraviButton, Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'
import { Col, Row } from 'antd'
import React, { useState } from 'react'
import { ProjectedDropToggle } from '../../../_SiteWide/TankDisplay/ProjectedDropToggle'
import { TankGraphWidget } from '../../../_SiteWide/TankDisplay/TankGraphWidget'

import { SalesVolume } from '../../../_SiteWide/TankDisplay/SalesVolume'
import { TankStats } from '../../../_SiteWide/TankDisplay/TankDetails'
import { useDestinationsContext } from '../../Contexts/DestinationsContext'
import { useWizardMaster } from '../../Contexts/WizardMasterContext'
import { DriverNotePreview } from './DisplayComponents/DriverNotePreview'

export function TankDrilldown({ showHeader = false }) {
  const { tankRundownData, selectedTank, selectedManifold, setSelectedTank, orderDestinations } =
    useDestinationsContext()
  const { rundownToggled, setRundownToggled, graphMarkers, toggleGraphMarker, driverNote } = useWizardMaster()
  const [volumeData, setVolumeData] = useState()

  const storeNumber = selectedManifold?.store_number || selectedTank?.store_number
  const store = orderDestinations.find((dest) => dest.store_number === storeNumber)

  return (
    <div>
      {driverNote && <DriverNotePreview />}
      <Row>
        <Horizontal className='flex-div items-center px-3 py-2' bg='primary' border='all' span={24} flex={1}>
          {showHeader && (
            <GraviButton
              className='mr-3'
              appearance='outline'
              theme2
              icon={<LeftOutlined />}
              onClick={() => setSelectedTank(undefined)}
            />
          )}
          <Texto category='h3' weight='bold' appearance='secondary' textTransform='uppercase'>
            {selectedManifold ? selectedManifold.manifold_id : selectedTank.product}
          </Texto>
          <Texto category='label' className='pl-3 pt-1'>{`TANK ${
            selectedManifold ? JSON.stringify(selectedManifold.tank_ids) : selectedTank.tank_id
          }`}</Texto>
        </Horizontal>
      </Row>

      <Row>
        <Col span={selectedTank?.manifold_id ? 24 : 16} className='pt-3 vertical-flex-center' align='right'>
          <TankStats
            timezone={store?.timezone}
            tank={selectedTank}
            tankRundownData={tankRundownData}
            selectedManifold={selectedManifold}
            rundownToggled={rundownToggled}
            store={store}
          />
          <Horizontal justifyContent='flex-end' alignItems='center' className='py-3' style={{ gap: '0.5rem' }}>
            <ProjectedDropToggle value={rundownToggled} onChange={() => setRundownToggled((flag) => !flag)} />
            <TankGraphWidget graphMarkers={graphMarkers} onMarkerChange={toggleGraphMarker} />
          </Horizontal>
          <Vertical flex={4} className='bg-1 mt-3' style={{ minHeight: 300, whiteSpace: 'initial' }}>
            <StoreDetailsTankRundown
              timezone={store?.timezone}
              tankRundownData={tankRundownData}
              tank={selectedTank}
              selectedManifold={selectedManifold}
              rundownToggled={rundownToggled}
              setRundownToggle={setRundownToggled}
              graphMarkers={graphMarkers}
            />
          </Vertical>
        </Col>
        {!selectedTank?.manifold_id && (
          <SalesVolume
            data={volumeData}
            setData={setVolumeData}
            selectedTank={selectedTank}
            selectedManifold={selectedManifold}
            store_number={selectedManifold ? selectedManifold.store_number : selectedTank.store_number}
            rundownToggled={rundownToggled}
          />
        )}
      </Row>
    </div>
  )
}
